module.exports = __webpack_public_path__ + "static/media/driveUpContext.506c1f7b.png";